import { render, staticRenderFns } from "./vehicle-summary.vue?vue&type=template&id=2d9f4f90&scoped=true&"
import script from "./vehicle-summary.vue?vue&type=script&lang=js&"
export * from "./vehicle-summary.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-summary.vue?vue&type=style&index=0&id=2d9f4f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f4f90",
  null
  
)

export default component.exports